import { TopicServiceFirestore } from "./TopicServiceFirestore";
import { TopicServiceLocal } from "./TopicServiceLocal";
export class TopicServiceFactory {
    static createLocal() {
        return new TopicServiceLocal();
    }
    static createFirestore(firestore) {
        if (!firestore) {
            throw new Error("Firestore instance is required for Firebase service");
        }
        return new TopicServiceFirestore(firestore);
    }
}
